var React = require('react');

function Account (props) {
    return React.createElement("svg",props,[React.createElement("mask",{"id":"mask0_5521_52579","style":{"maskType":"alpha"},"maskUnits":"userSpaceOnUse","x":"0","y":"0","width":"24","height":"24","key":0},React.createElement("rect",{"width":"24","height":"24","fill":"#D9D9D9"})),React.createElement("g",{"mask":"url(#mask0_5521_52579)","key":1},React.createElement("path",{"d":"M17.425 8.4635H18.8288V7.05975H17.425V8.4635ZM17.425 12.6615H18.8288V11.2578H17.425V12.6615ZM17.425 16.8443H18.8288V15.4405H17.425V16.8443ZM15.7845 20.5V19.3652H21.3652V4.63475H11.423V7.45375L10.2885 6.6635V3.5H22.5V20.5H15.7845ZM1.5 20.5V11.4328L7.83275 6.90975L14.15 11.4295V20.5H9.20575V15.7345H6.4595V20.5H1.5ZM2.63475 19.3652H5.325V14.6H10.3403V19.3652H13.0155V12.0155L7.83275 8.327L2.63475 12.0285V19.3652Z","fill":"#00050A"}))]);
}

Account.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Account;

Account.default = Account;
